import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Journey from "@/components/site/Journey";
import Ventures from "@/components/site/Ventures";
import Quotes from "@/components/site/Quotes";
import GlobalWork from "@/components/site/GlobalWork";
import Fundraising from "@/components/site/Fundraising";
import SearchFund from "@/components/site/SearchFund";
import Gallery from "@/components/site/Gallery";
import Journal from "@/components/site/Journal";
import ImpactForm from "@/components/site/ImpactForm";
import Footer from "@/components/site/Footer";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const [preset, setPreset] = useState({ type: "general", related: "" });
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const target = location.state.scrollTo;
      setTimeout(() => scrollToId(target), 500);
    }
  }, [location.state]);

  const enquire = (type, related = "") => {
    setPreset({ type, related });
    setTimeout(() => scrollToId("impact"), 50);
  };

  return (
    <main data-testid="home-page">
      <Header />
      <Hero />
      <Marquee />
      <About />
      <Journey />
      <Ventures />
      <Quotes />
      <GlobalWork />
      <Fundraising onEnquire={enquire} />
      <SearchFund onEnquire={enquire} />
      <Gallery />
      <Journal />
      <ImpactForm preset={preset} />
      <Footer />
    </main>
  );
}
